import React from 'react';
import { TeacherOverview } from './teacher/TeacherOverview';
import { AssignmentManager } from './teacher/AssignmentManager';
import { DraftDataAnalytics } from './teacher/DraftDataAnalytics';
import { FlowRubric } from './teacher/FlowRubric';
import { GoogleClassroom } from './teacher/GoogleClassroom';
import { FlowGradeView } from './teacher/FlowGradeView';

export const TeacherDashboard = ({ activeTab = 'dashboard', onTabChange }) => {
  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard': return <TeacherOverview onTabChange={onTabChange} />;
      case 'assignments': return <AssignmentManager />;
      case 'flowgrade': return <FlowGradeView />;
      case 'analytics': return <DraftDataAnalytics />;
      case 'rubric': return <FlowRubric />;
      case 'classroom': return <GoogleClassroom />;
      default: return <TeacherOverview onTabChange={onTabChange} />;
    }
  };

  return renderContent();
};

export default TeacherDashboard;
